/**
 * Whether the People Browser (BIZY-635) should render.
 *
 * Single source of truth for the gate so the panel layout, the notification
 * peek repointing, and future People Browser UI all agree.
 */
export function usePeopleBrowserEnabled(): boolean {
	return true;
}
